import { BaseFeatureItemDto } from '../../base/dtos/base-feature-item.dto';
import { VehicleCategoryFeatureItemTypeEnum } from '../enums/vehicle-category-feature-item-type.enum';

/**
 * Vehicle category feature item DTO
 */
export class VehicleCategoryFeatureItemDto extends BaseFeatureItemDto {
	type!: VehicleCategoryFeatureItemTypeEnum;
}
